import { useEffect, useRef, useState } from "react";
import "./Businesses.scss";
import {
  view,
  exports,
  filterSearch,
  back,
  fullScreen,
  openarrow,
  penwitharrow,
  createnote,
  redDelete,
  dataLoading,
  Download,
} from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import toastr from "../elements/toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import NoDataFound from "../NoDataFound/NoDataFound";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import {
  countryWiseRegex,
  exportCSVBusiness,
  exportHeaderForBusiness,
  financedAvg,
  getAvgInterestRate,
  getLanguage,
  getStorageValue,
  utc_to_local,
} from "../../service/shared.service";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "../../utils/Pagination";
import { DateRangePicker } from "react-date-range";
import { formatDate, formatDate2 } from "../../utils/DateFormat";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Table from "../elements/tableComponent";
import NoDataRightScreen from "../NoDataRightScreen/NoDataRightScreen";
import CurrencyFormatter, { formatCurrencyUSA } from "../../utils/CurrencyFormatter";
import { Spinner } from "react-bootstrap";
const Businesses = () => {
  const columns = [
    {
      title: "Sr.",
      dataKey: "serialNumber",
    },
    {
      title: "Business",
      dataKey: "businessName",
    },
    {
      title: "Business ID",
      dataKey: "businessID",
    },
    {
      title: "Registered Date",
      dataKey: "registeredDate",
    },
    {
      title: "Payment Plans Amount",
      dataKey: "paymentPlansAmount",
    },
    {
      title: "Total Payment Plans",
      dataKey: "totalPaymentPlans",
    },
    {
      title: "Status",
      dataKey: "status",
    },
  ];
  const toastrService = new toastr(true);
  const navigate = useNavigate();
  const [selectedTabs, setSelectedTabs] = useState();
  const [records, setRecords] = useState();
  const [listData, setListData] = useState([]);
  const [listDataFilter, setListDataFilter] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  let [searchInput, setSearchInput] = useState("");
  const partnerData = useSelector((state: any) => state?.APIData?.partnerData);
  const [currencyLogo, setCurrencyLogo] = useState();
  const [mobileCode, setMobileCode] = useState();
  const [colour, setColour] = useState(0);
  const [partnerFullData, setpartnerFullData] = useState<any>(false);
  const [notesData, setNotesData] = useState([]);
  const [notesopen, setNotesOpen] = useState(false);
  const [textnotes, setTextNotes] = useState(false);
  const [tablevar, setTablevar] = useState(false);
  const [shimmerEffect, setShimmerEffect] = useState(false);
  const [detailsShimmerEffect, setDetailsShimmerEffect] = useState(false);
  const [textareaData, setTextareaData] = useState("");
  const [textareaData2, setTextareaData2] = useState({
    note: '',
    an_id: 0
  });
  const [selectedChoice, setSelectedChoice] = useState({
    label: "All",
    value: "0",
  });
  const [exportCSVData, setexportCSVData] = useState({
    headers: [],
    data: [],
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [show, setShow] = useState(false);
  const prevSearchInputRef = useRef('');
  const [sppiner, setSppiner] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteAnId, setDeleteAnId] = useState(0);
  const handleChoiceSelection = (item: any) => {
    setSelectedChoice(item);
    doctorList(item, false);
  };
  const [dateFilterData, setdateFilter] = useState<any>();
  const choices = [
    {
      value: 0,
      label: "All",
    },
    {
      value: 1,
      label: "Active",
    },
    {
      value: 2,
      label: "Inactive",
    },
  ];

  if (!partnerData?.user_partner_info?.pu_id) {
    columns.splice(columns.length - 1, 0, {
      title: "Commission Earned",
      dataKey: "commissionEarned",
    },
      {
        title: "Commission Expected",
        dataKey: "commissionExpected",
      })
    // console.log('columnscolumns', columns);
  }
  useEffect(() => {
    const getReferal = searchParams.get("referCode");
    const data = (localStorage.getItem("businessGridView") + '') == '1' ? true : false;
    setpartnerFullData(data);

    if (getReferal) {
      searchInput = getReferal;
      setSearchInput(getReferal);

    }
    doctorList(0, false);
    if (partnerData) {
      const displayLogo =
        partnerData &&
        partnerData["country_currency_info"] &&
        partnerData["country_currency_info"]["currency"] &&
        partnerData["country_currency_info"]["currency"][0];
      const mobileCode =
        partnerData &&
        partnerData["country_currency_info"] &&
        partnerData["country_currency_info"]["country"];
      setCurrencyLogo(displayLogo);
      setMobileCode(mobileCode);
      // console.log(displayLogo);
    }
    prevSearchInputRef.current = searchInput;
  }, [partnerData]);
  const exportType = {
    XLSX: "XLSX",
    CSV: "CSV",
  };
  let getProfile: any = getStorageValue("partnerProfile");
  const deleteData = () => {
    if (searchParams.get("referCode")) {
      searchParams.delete("referCode");
      setSearchParams(searchParams);
    }
    searchInput = "";
    setSearchInput("");
    doctorList(0, false);
    setdateFilter({});
  };
  const exportdcotorList = async (exportType: any = "", dateFilter: boolean = false) => {
    setShimmerEffect(true);
    setDetailsShimmerEffect(true);
    if (getProfile && getProfile.length) {
      getProfile = getProfile[0];
    }
    // const getProfile = JSON.parse(profile).partnerProfile[0];
    setSelectedTabs(getProfile);
    const body = {
      access_token: getProfile.access_token,
      limit: 0,
      filter: 0,
      search_string: searchInput,
      para_id: getProfile.para_id,
      partner_json: getProfile.partner_json,
      offset: 0,
      added_by: 1,
      referral_code: getProfile.referral_code,
      sort_order: "",
      time_offset: "",
      sort_by: "",
      current_agent_id: "",
      language_preffered: getProfile.language_preffered,
      start_date: (dateFilterData && dateFilterData.startDate) || dateFilter ? (selectionRange.startDate) : undefined,
      end_date: (dateFilterData && dateFilterData.startDate) || dateFilter ? (selectionRange.endDate) : undefined,
      list_view: ((localStorage.getItem("businessGridView") + '') == '1') || 1
    };
    await httpApiCall({ api: "show_doctor_list", type: "post", body })
      .then(async (data) => {
        setDetailsShimmerEffect(false);
        setShimmerEffect(false);
        if (data && !data.is_error) {
            exportCSV(exportType, data.paginated_doctors);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  }
  const doctorList = async (
    filterData: any,
    exportFile: boolean = false,
    exportType: any = "",
    offset?: any,
    dateFilter: boolean = false
  ) => {
    setShimmerEffect(true);
    setDetailsShimmerEffect(true);
    if (getProfile && getProfile.length) {
      getProfile = getProfile[0];
    }
    // const getProfile = JSON.parse(profile).partnerProfile[0];
    setSelectedTabs(getProfile);
    const body = {
      access_token: getProfile.access_token,
      limit: exportFile ? 0 : 10,
      filter: filterData && filterData.value ? filterData.value : filterData,
      search_string: searchInput,
      para_id: getProfile.para_id,
      partner_json: getProfile.partner_json,
      offset: offset ? offset : 0,
      added_by: 1,
      referral_code: getProfile.referral_code,
      sort_order: "",
      time_offset: "",
      sort_by: "",
      current_agent_id: "",
      language_preffered: getProfile.language_preffered,
      start_date: (dateFilterData && dateFilterData.startDate) || dateFilter ? (selectionRange.startDate) : undefined,
      end_date: (dateFilterData && dateFilterData.startDate) || dateFilter ? (selectionRange.endDate) : undefined,
      list_view: ((localStorage.getItem("businessGridView") + '') == '1') || exportFile ? 1 : 0
    };
    setListData([]);
    await httpApiCall({ api: "show_doctor_list", type: "post", body })
      .then(async (data) => {
        setDetailsShimmerEffect(false);
        setShimmerEffect(false);
        if (data && !data.is_error) {
          setRecords(data);
          const listOfData = data.paginated_doctors;
          if (listOfData && listOfData.length && partnerData && partnerData["country_currency_info"]) {
            setListData(listOfData);
            getBusinessDetails(listOfData[0]['doctor_id']);
            // holdOn(listOfData[0], 0);
          }
          if (dateFilter) {
            setdateFilter(selectionRange);
            // const valueOne = new Date(selectionRange.startDate)
            //   .toDateString()
            //   .slice(4);
            // const valueTwo = new Date(selectionRange.endDate)
            //   .toDateString()
            //   .slice(4);
            // setSearchInput(valueOne + " to " + valueTwo);
          }
          // if (exportFile) {
          //   exportCSV(exportType);
          // }
        } else {
          setListDataFilter(undefined);
          // toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };

  const getBusinessDetails = async (doctor_id: any) => {
    if (listDataFilter && listDataFilter['doctor_id'] == doctor_id) {
      return;
    }
    const obj = {
      access_token: getStorageValue('partnerToken'),
      doctor_id: doctor_id
    }
    setDetailsShimmerEffect(true);
    const detailsData = await httpApiCall({ api: "show_doctor_details", type: "post", body: obj })
    setDetailsShimmerEffect(false);
    if (detailsData && !detailsData.is_error) {

      if (detailsData.data && detailsData.data.practice_mobile) {
        detailsData.data.practice_mobile = detailsData.data.practice_mobile.replace(countryWiseRegex[partnerData["country_currency_info"]['country']['country_code']]['regex'], countryWiseRegex[partnerData["country_currency_info"]['country']['country_code']]['group'])
      }
      // console.log(countryWiseRegex)
      if (detailsData.data && detailsData.data.doctor_mobile) {
        detailsData.data.doctor_mobile = detailsData.data.doctor_mobile.replace(countryWiseRegex[partnerData["country_currency_info"]['country']['country_code']]['regex'], countryWiseRegex[partnerData["country_currency_info"]['country']['country_code']]['group'])
      }
      setListDataFilter(detailsData.data);
    } else {
      setListDataFilter(undefined);
    }
  }

  const rows = listData && listData.map((row: any, index: number) => {
    const singleRow = [
      index + 1,
      row.doctor_first_name + row.doctor_last_name,
      row.referral_code,
      formatDate2(row.date_registered),
      formatCurrencyUSA(row.total_financed_amount),
      row.total_payment_plan || 0,
      row.active_inactive_status,
    ]
    if (!partnerData?.user_partner_info?.pu_id) {
      singleRow.splice(singleRow.length - 1, 0,
        formatCurrencyUSA(row.total_earning || 0))
      singleRow.splice(singleRow.length - 1, 0,
        formatCurrencyUSA(row.total_upcoming_earnings || 0))
    }
    return singleRow;
  });
  const getFirstName = (first: any, last: any) => {
    let firstName = first + "-" + last;
    const split = `${firstName}`.split("-");
    if (split.length > 1) {
      return String(split[0][0] + split[1][0]);
    } else if (Number(split.length) === 1) {
      return split[0][0].toUpperCase();
    }
  };
  const holdOn = (item: any, index: any) => {
    // setListDataFilter(item);
    setColour(index);
    setNotesOpen(false);
    // setSearchParams({ id: item.doctor_id });
    if (!tablevar) {
      setpartnerFullData(false);
      // setGridtolist(true)
    }
    getBusinessDetails(item['doctor_id']);
  };

  const showNotes = async () => {
    if (notesopen) {
      setNotesOpen(false);
      return;
    }
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      doctor_id: listDataFilter && listDataFilter["doctor_id"],
      limit: 10,
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    await httpApiCall({ api: "get_notes", type: "post", body }).then(
      (data: any) => {
        if (data && data.is_error == 0) {
          // console.log(data);
          setNotesData(data.notes);
          setNotesOpen(true);
          if (notesopen) {
            setTextNotes(false);
            // setNotesOpen(false);
            setTextareaData("");
          }
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      }
    );
  };

  const submitNotes = async () => {
    if (!textareaData) {
      toastrService.showError("Please enter note");
      return;
    }
    if (textareaData == textareaData2.note) {
      toastrService.showError("The current note must differ from the previous one.");
      return;
    }
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      doctor_id: listDataFilter && listDataFilter["doctor_id"],
      is_update: textareaData2.note ? 1 : 0,
      an_id: textareaData2.an_id ? textareaData2.an_id : undefined,
      note: textareaData,
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    setSppiner(true);
    await httpApiCall({ api: "add_agent_note", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data) {
          // console.log("successful");
          toastrService.showSuccess("Note saved sucessfully");
          showNotes();
          setTextareaData("");
          setTextareaData2({
            note: '',
            an_id: 0
          });
          setTextNotes(false);
        } else {
          toastrService.showError("Error while saving note");
        }
      })
      .catch((error) => {
        setSppiner(false);
        console.log("error");
      });
  };
  const checkLength = (event: any) => {
    const { value } = event.target;    
    const trimmedValue = value.trimStart();
    setTextareaData(trimmedValue);
  };

  const createNewNote = (note: any, id: any) => {
    setTextareaData(note);
    setTextareaData2({
      note: note,
      an_id: id
    });
    setTextNotes(true);
  };
  const deleteConfirm = async () => {
    setSppiner(true);
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      an_id: deleteAnId,
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    await httpApiCall({ api: "delete_notes", type: "post", body })
      .then((data) => {
        setSppiner(false);
        setShowDeleteModal(false);
        if (data) {
          toastrService.showSuccess(data.msg);
          // console.log("successful");
          showNotes();
        } else {
          toastrService.showError("Error in notes");
          return;
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const exportCSV = async (a: any, doctorData:any) => {
    const data = await exportCSVBusiness(a, selectedTabs, partnerData, doctorData, currencyLogo)
    if (a == exportType.CSV && data.headers) {
      setexportCSVData({
        headers: data.headers,
        data: data.dataList,
      });
      setTimeout(() => {
        const link: any = document.getElementById("custom-hidden");
        if (link) {
          link.setAttribute("download", "Businesses" + ".csv");
          link.click();
        }
      }, 1000);
    }
    // if (a == exportType.XLSX) {
    //   dataList.unshift(headers);
    //   const workbook = XLSX.utils.book_new();
    //   const worksheet = XLSX.utils.aoa_to_sheet(dataList);
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //   // Save workbook as XLSX file
    //   XLSX.writeFile(workbook, "XLSX" + ".xlsx");
    // }
  };

  const handlePageChange = (offset: number) => {
    // console.log(offset, "offset");
    let data = (offset - 1) * 10;
    doctorList(0, false, "", data);
  };
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const handleSelect = ({ selection }: any) => {
    setdateFilter(selection);
    setSelectionRange(selection);
    // console.log(selection);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      headStyles: { fillColor: [1, 61, 80] },
      head: [columns.map((item) => item.title)],
      body: rows,
      styles: {
        fontSize: 9,
      },
    });

    doc.save("Business List.pdf");
  };
  // console.log(listData,listDataFilter);

  const receiveData = async (index: any = {}) => {
    setTablevar(true);
    holdOn(listData[index], index);
  }
  return (
    <>
      {!partnerFullData && (
        <div className="Buissness-main p-0">
          <div className="container-fluid position-relative">
            {
              // shimmerEffect ? (
              //   <div className="no_data_v2 text-center">
              //     <img src={dataLoading} alt="" />
              //   </div>
              // ) :(
              <div className="row">
                <div
                  className={`${tablevar == true ? "d-none" : !visible ?  "col-lg-3 p-0" : "col-lg-3 d-none"}`}
                >
                  <div className="left-wrapper">
                    {shimmerEffect ? (
                      <div className="no_data_v2 text-center">
                        <img src={dataLoading} alt="" />
                      </div>
                    ) :
                      <div>
                        <div className="left-header">
                          <div className="App">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="Secondary"
                                id="dropdown-basic"
                              >
                                {selectedChoice.label}
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {choices.map((item, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => handleChoiceSelection(item)}
                                  >
                                    {item.label}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="list_view d-none d-lg-block">
                              <img
                                className="me-3"
                                src={view}
                                alt=""
                                onClick={() => {
                                  setpartnerFullData(true);
                                  localStorage.setItem("businessGridView", '1')
                                  doctorList(0, false);
                                }}
                              />
                              <span></span>
                            </div>
                            {records && records["number_of_records"] > 0 && <div>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="Secondary"
                                  id="dropdown-basic"
                                >
                                  <img src={exports} alt="" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    id="xlsx"
                                    onClick={() =>
                                      exportdcotorList(exportType.XLSX)
                                    }
                                  >
                                    XLSX
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                  id="csv"
                                    onClick={() =>
                                      exportdcotorList(exportType.CSV)
                                    }
                                  >
                                    CSV
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>}
                          </div>
                        </div>
                        <div className="search-bar">
                          <input
                          id="search-inpu2"
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            name="search"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                doctorList(0, false);
                              }
                            }}
                          />
                          {(searchInput || (dateFilterData && dateFilterData.startDate)) && (
                            <label
                              className="filter"
                              onClick={deleteData}
                            ></label>
                          )}
                          <div
                            onClick={() => setShow(true)}
                            className="date_range"
                          >
                            <img src={filterSearch} alt="" />
                          </div>
                        </div>
                      </div>}
                    {listData && !listData.length && (
                      <div className="nocompo">
                        <NoDataFound />
                      </div>
                    )}
                    {!shimmerEffect && <div
                      className={`${listData && listData.length > 0 ? "loop" : ""
                        }`}>
                      {listData && listData.length > 0
                        ? listData.map((item: any, index) => (
                          <div
                            className={`listing first_index ${index == colour ? "colour_chnage" : ""
                              }`}
                            key={index}
                            onClick={() => {
                              setTablevar(false);
                              holdOn(item, index);
                            }}
                          >
                            <div className="listing__left">
                              <h5>
                                {item.doctor_first_name}{" "}
                                {item.doctor_last_name}
                              </h5>
                              <p>
                                Registered on{" "}
                                {`${new Date(
                                  item.date_registered
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                })}`}
                              </p>
                            </div>
                            <div className="listing__right">
                              <p className={item.active_inactive_status}>
                                {item.active_inactive_status}
                              </p>
                                <div>
                                <p className="status-content d-lg-none" onClick={() => setVisible(true)} >
                                View Details
                            </p>
                                </div>
                            </div>
                          </div>
                        ))
                        : ""}
                    </div>}
                    {records && records["number_of_records"] > 10 && (
                      <div className="pagination-business position-relative">
                        <Pagination
                          totalItems={records && records["number_of_records"]}
                          itemsPerPage={records && records["number_of_pages"]}
                          onPageChange={(offset: number) =>
                            handlePageChange(offset)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`${
                    !tablevar && !visible ? `col-lg-9  d-none d-lg-block` : "col-12 grid_partner"
                  }`}
                >
                  {tablevar && (
                    <div
                      className="back-button"
                      onClick={() => {
                        setpartnerFullData(true);
                        setTablevar(false);
                      }}
                    >
                      <img src={back} alt="" />
                      <span>Back</span>
                    </div>
                  )}

                  {detailsShimmerEffect ? (
                    <div className="no_data_v2 text-center">
                      <img src={dataLoading} alt="" />
                    </div>
                  ) : (
                    <>
                      {(listData && !listData.length) ? (
                        <div className="nocompo">
                          <NoDataRightScreen />
                        </div>
                      ) :
                        (listDataFilter && (
                          <div className="rightWrapper">
                            <div className="layout-wrapper__right">
                              <div className="add_business">
                                  <span className="back-btn d-lg-none" onClick={() => setVisible(false)}></span>
                                <div className="main--wrapper">
                                  <div className="main--wrapper-profile">
                                    <h1 className={listDataFilter['doctor_image']?'h1':''}>{listDataFilter && listDataFilter['doctor_image'] ? <img src={listDataFilter['doctor_image']} alt="" /> : `${getFirstName(
                                      listDataFilter["doctor_first_name"],
                                      listDataFilter["doctor_last_name"]
                                    )}`}</h1>
                                  </div>

                                  <div className="personal__info">
                                    <div className="name">
                                      <p>
                                        {listDataFilter["doctor_first_name"]}{" "}
                                        {listDataFilter["doctor_last_name"]}
                                        <span className={listDataFilter && listDataFilter["active_inactive_status"]}>
                                          {listDataFilter &&
                                            listDataFilter[
                                            "active_inactive_status"
                                            ]}
                                        </span>
                                      </p>
                                      {/* <p className="register">
                                        Registered on{" "}
                                        {`${new Date(
                                          `${listDataFilter &&
                                          listDataFilter["date_registered"]
                                          }`
                                        ).toLocaleDateString("en-US", {
                                          year: "numeric",
                                          month: "2-digit",
                                          day: "2-digit",
                                        })}`}
                                      </p> */}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="business-wrapper--header">
                                {!partnerData?.user_partner_info?.pu_id && <div className="business-wrapper--left">
                                  <p className="badge__info">
                                   <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.75 15.9198H13.4C14.05 15.9198 14.59 15.3398 14.59 14.6398C14.59 13.7698 14.28 13.5998 13.77 13.4198L12.76 13.0698V15.9198H12.75Z" fill="#007094"/>
<path d="M11.9701 1.89992C6.45007 1.91992 1.98007 6.40992 2.00007 11.9299C2.02007 17.4499 6.51007 21.9199 12.0301 21.8999C17.5501 21.8799 22.0201 17.3899 22.0001 11.8699C21.9801 6.34992 17.4901 1.88992 11.9701 1.89992ZM14.2601 11.9999C15.0401 12.2699 16.0901 12.8499 16.0901 14.6399C16.0901 16.1799 14.8801 17.4199 13.4001 17.4199H12.7501V17.9999C12.7501 18.4099 12.4101 18.7499 12.0001 18.7499C11.5901 18.7499 11.2501 18.4099 11.2501 17.9999V17.4199H10.8901C9.25007 17.4199 7.92007 16.0399 7.92007 14.3399C7.92007 13.9299 8.26007 13.5899 8.67007 13.5899C9.08007 13.5899 9.42007 13.9299 9.42007 14.3399C9.42007 15.2099 10.0801 15.9199 10.8901 15.9199H11.2501V12.5399L9.74007 11.9999C8.96007 11.7299 7.91007 11.1499 7.91007 9.35992C7.91007 7.81992 9.12007 6.57992 10.6001 6.57992H11.2501V5.99992C11.2501 5.58992 11.5901 5.24992 12.0001 5.24992C12.4101 5.24992 12.7501 5.58992 12.7501 5.99992V6.57992H13.1101C14.7501 6.57992 16.0801 7.95992 16.0801 9.65992C16.0801 10.0699 15.7401 10.4099 15.3301 10.4099C14.9201 10.4099 14.5801 10.0699 14.5801 9.65992C14.5801 8.78992 13.9201 8.07992 13.1101 8.07992H12.7501V11.4599L14.2601 11.9999Z" fill="#007094"/>
<path d="M9.42188 9.37008C9.42188 10.2401 9.73187 10.4101 10.2419 10.5901L11.2519 10.9401V8.08008H10.6019C9.95188 8.08008 9.42188 8.66008 9.42188 9.37008Z" fill="#007094"/>
</svg>

                                    Commission Earned:
                                    <span className="color-green fs-14-contentwrap ms-1 notranslate">
                                      <CurrencyFormatter
                                        amount={
                                          listDataFilter &&
                                            listDataFilter["total_profit_earned"]
                                            ? listDataFilter[
                                            "total_profit_earned"
                                            ]
                                            : 0
                                        }
                                      />
                                    </span>
                                  </p>
                                  <p className="badge__info">
                                    <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M18.8086 6.24998H20.1686C19.9786 5.97998 19.7786 5.72998 19.5686 5.47998L18.8086 6.24998Z" fill="#F77600" />
                                      <path d="M18.52 4.41982C18.27 4.20982 18.02 4.00982 17.75 3.81982V5.17982L18.52 4.41982Z" fill="#F77600" />
                                      <path d="M19.5795 5.47994L22.5295 2.52994C22.8195 2.23994 22.8195 1.75994 22.5295 1.46994C22.2395 1.17994 21.7595 1.17994 21.4695 1.46994L18.5195 4.41994C18.8995 4.74994 19.2495 5.10994 19.5795 5.47994Z" fill="#F77600" />
                                      <path d="M17.7517 3C17.7517 2.59 17.4117 2.25 17.0017 2.25C16.6017 2.25 16.2817 2.57 16.2617 2.96C16.7817 3.21 17.2817 3.49 17.7517 3.82V3Z" fill="#F77600" />
                                      <path d="M21.7519 7C21.7519 6.59 21.4119 6.25 21.0019 6.25H20.1719C20.5019 6.72 20.7919 7.22 21.0319 7.74C21.4319 7.72 21.7519 7.4 21.7519 7Z" fill="#F77600" />
                                      <path d="M12.75 14.7498H13.05C13.44 14.7498 13.75 14.3998 13.75 13.9698C13.75 13.4298 13.6 13.3498 13.26 13.2298L12.75 13.0498V14.7498Z" fill="#F77600" />
                                      <path d="M21.04 7.74C21.03 7.74 21.02 7.75 21 7.75H17C16.9 7.75 16.81 7.73 16.71 7.69C16.53 7.61 16.38 7.47 16.3 7.28C16.27 7.19 16.25 7.1 16.25 7V3C16.25 2.99 16.26 2.98 16.26 2.96C14.96 2.35 13.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.48 21.65 9.04 21.04 7.74ZM13.75 11.82C14.39 12.04 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z" fill="#F77600" />
                                      <path d="M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z" fill="#F77600" />
                                    </svg>

                                    Commission Expected:
                                    <span className="color-blue fs-14-contentwrap ms-1 notranslate">
                                      <CurrencyFormatter
                                        amount={
                                          listDataFilter &&
                                            listDataFilter[
                                            "total_upcoming_earnings"
                                            ]
                                            ? listDataFilter[
                                            "total_upcoming_earnings"
                                            ]
                                            : 0
                                        }
                                      />
                                    </span>
                                  </p>
                                </div>}
                              </div>

                              <div
                                className="accordion"
                                id="accordionPanelsStayOpenExample"
                              >
                                <div className="accordion-item mb-3">
                                  <h2
                                    className="accordion-header"
                                    id="headingOne"
                                  >
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseOne"
                                      aria-expanded="true"
                                      aria-controls="collapseOne"
                                      id="accordion-btn"
                                    >
                                      Business Overview
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Total Payment Plan Amount:
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {currencyLogo &&
                                              currencyLogo["display_logo"]}
                                            {listDataFilter &&
                                              listDataFilter[
                                              "total_amount_financed"
                                              ]
                                              ? listDataFilter[
                                              "total_amount_financed"
                                              ]
                                              : 0}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Total Payment Plans:
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["total_payment_plans"]
                                              ? listDataFilter[
                                              "total_payment_plans"
                                              ]
                                              : 0}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Registration Date:
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {" "}
                                            {`${new Date(
                                              `${listDataFilter &&
                                              listDataFilter["date_registered"]
                                              }`
                                            ).toLocaleDateString("en-US", {
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })}`}
                                          </p>
                                        </div>
                                        <div className="col-4 mt-4">
                                          <h5 className="mb-0 sub-head">
                                            First Contract:
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["first_contract_date"]
                                              ? `${new Date(
                                                `${listDataFilter &&
                                                listDataFilter[
                                                "first_contract_date"
                                                ]
                                                }`
                                              ).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                              })}`
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-4 mt-4">
                                          <h5 className="mb-0 sub-head">
                                            Last Contract:
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["last_contract_date"]
                                              ? `${new Date(
                                                `${listDataFilter &&
                                                listDataFilter[
                                                "last_contract_date"
                                                ]
                                                }`
                                              ).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                              })}`
                                              : "N.A"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="accordion-item mb-3">
                                  <h2
                                    className="accordion-header"
                                    id="headingTwo"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseTwo"
                                      aria-expanded="false"
                                      aria-controls="collapseTwo"
                                      id="bussinessTwo"
                                    >
                                      Business Details
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Business ID
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["referral_code"]
                                              ? listDataFilter &&
                                              listDataFilter["referral_code"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Business Email
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["practice_email"]
                                              ? listDataFilter &&
                                              listDataFilter["practice_email"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Business Phone
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["practice_mobile"] ? (
                                              <span>
                                                {mobileCode &&
                                                  mobileCode["mobile_code"]}
                                                -
                                              </span>
                                            ) : (
                                              ""
                                            )}{" "}
                                            {listDataFilter &&
                                              listDataFilter["practice_mobile"]
                                              ? listDataFilter &&
                                              listDataFilter["practice_mobile"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Industry
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["ind_name"]
                                              ? listDataFilter &&
                                              listDataFilter["ind_name"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Sub Industry
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["speciality_name"]
                                              ? listDataFilter &&
                                              listDataFilter["speciality_name"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Business Address
                                          </h5>
                                          <p className="mb-0 sub-para">
                                          {listDataFilter &&
                                              listDataFilter["practice_address"]
                                              ?  (listDataFilter["practice_address"]  + ', ' + listDataFilter['practice_zip'] + ', ' + listDataFilter['practice_city'] + ', ' + listDataFilter['practice_state'])
                                              : "N.A"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="accordion-item mb-3">
                                  <h2
                                    className="accordion-header"
                                    id="headingThree"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseThree"
                                      aria-expanded="false"
                                      aria-controls="collapseThree"
                                      id="buttonThree"
                                    >
                                      Owner Details
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Business Owner Name
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["doctor_first_name"]
                                              ? listDataFilter &&
                                              listDataFilter[
                                              "doctor_first_name"
                                              ]
                                              : "N.A"}
                                            {listDataFilter &&
                                              listDataFilter["doctor_last_name"]}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Owner Email
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["doctor_email"]
                                              ? listDataFilter &&
                                              listDataFilter["doctor_email"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Owner Phone
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["doctor_mobile"] ? (
                                              <span>
                                                {mobileCode &&
                                                  mobileCode["mobile_code"]}
                                                -
                                              </span>
                                            ) : (
                                              ""
                                            )}{" "}
                                            {listDataFilter &&
                                              listDataFilter["doctor_mobile"]
                                              ? listDataFilter &&
                                              listDataFilter["doctor_mobile"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Owner Address
                                          </h5>
                                          <p className="mb-0 sub-para">
                                          {listDataFilter &&
                                              listDataFilter["doctor_address"]
                                              ?  ((listDataFilter["doctor_address"]  + ', ' + listDataFilter['zip'] + ', ' + listDataFilter['city'] + ', ' + listDataFilter['state']))
                                              : "N.A"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingFour"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseFour"
                                      aria-expanded="false"
                                      aria-controls="collapseFour"
                                      id="bussinessFour"
                                    >
                                      Manager Details
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Manager Name
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["manager_name"]
                                              ? listDataFilter &&
                                              listDataFilter["manager_name"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Manager Email
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["manager_email"]
                                              ? listDataFilter &&
                                              listDataFilter["manager_email"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-md-0 mb-3">
                                          <h5 className="mb-0 sub-head">
                                            Manager Phone
                                          </h5>
                                          <p className="mb-0 sub-para">
                                            {listDataFilter &&
                                              listDataFilter["manager_mobile"]
                                              ? listDataFilter &&
                                              listDataFilter["manager_mobile"]
                                              : "N.A"}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </>
                  )}

                  {/* notes section open */}
                  {(tablevar || !partnerFullData) &&
                    listData &&
                    listData.length > 0 && (
                      <div
                        className={`partner_notes ${notesopen ? "transformNote-main" : ""
                          }`}
                      >
                        <p
                          onClick={showNotes}
                          className={`partner_notes_open ${!partnerData?.user_partner_info?.pu_id ? '' : "top-120"} ${notesopen ? "transformNote" : ""
                            }`}
                        >
                          <span
                            className={`arrow ${notesopen ? "closearrow" : ""}`}
                          >
                            <img src={openarrow} alt="" />
                          </span>
                          <span className="notes-content">
                            <img src={penwitharrow} alt="" />
                            <span>Notes</span>
                          </span>
                        </p>
                        {notesopen && (
                          <div className="partner_notes_started">
                            <div className="noteheader">
                              <div className="noteheader_one">
                              <div className="notes_cross d-sm-none " onClick={showNotes}>
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                          </svg></div>
                                <p> Notes</p>
                              
                                <p>
                                  You can add/update notes for business owner.{" "}
                                </p>
                              </div>

                              <div className="noteheader-input">
                                <div>
                                  {textnotes ? (
                                    <div>
                                      <div className="create-note-inputform">
                                        <textarea
                                          className="w-100"
                                          placeholder="Description"
                                          rows={5}
                                          onChange={checkLength}
                                          value={textareaData}
                                        ></textarea>
                                      </div>
                                      <div className="btn--group">
                                        <button
                                          className="save"
                                          onClick={() => submitNotes()}
                                          disabled={sppiner}
                                          id="submitNotes"
                                        >
                                          <span className={sppiner ? 'mr-2' : ''}>Save</span>
                                          {sppiner && (
                                            <Spinner
                                              className="ml-2"
                                              as="span"
                                              animation="border"
                                              size="sm"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                          )}
                                        </button>
                                        <button
                                        id="setTextNotes"
                                          className="cancel"
                                          onClick={() => {
                                            setTextNotes(false);
                                            setTextareaData("");
                                          }}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <button
                                      id="createNewNote"
                                        className="button-font create-btn"
                                        onClick={() => setTextNotes(true)}
                                      >
                                        + Create New Note
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="notes-modal--body">
                              {notesData && notesData.length > 0
                                ? notesData.map((item, index) => (
                                  <div className="notes-modal--body-card">
                                    <div className="card-header">
                                      <div className="card-header-content">
                                        <p className="fs-14-contentwrap">
                                          {item && item["note"]}
                                        </p>
                                      </div>
                                      <div className="card-header-images">
                                        <span
                                          onClick={() =>
                                            createNewNote(
                                              item["note"],
                                              item["an_id"]
                                            )
                                          }
                                        >
                                          <img src={createnote} alt="" />
                                        </span>
                                        <span
                                          onClick={() => {
                                            setShowDeleteModal(true);
                                            setDeleteAnId(item["an_id"]);
                                          }}
                                        >
                                          <img src={redDelete} alt="" />
                                        </span>
                                      </div>
                                    </div>
                                    <div className="card-footer">
                                      <span className="date fs-12-mini-paragraph notranslate">
                                        {`${item && item["date_added"]
                                            ? new Date(
                                              item["date_added"]
                                            ).toLocaleDateString("en-US", {
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })
                                            : ""
                                          }`}
                                      </span>
                                      <span className="time fs-12-mini-paragraph notranslate">
                                        {`${item && item["date_added"]
                                            ? new Date(
                                              item["date_added"]
                                            ).toLocaleTimeString([], {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                            })
                                            : ""
                                          }`}
                                      </span>
                                    </div>
                                  </div>
                                ))
                                : ""}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  {/* <div
                    className="add_sub_partner"
                    onClick={() => navigate("/app/new-business")}
                  >
                    <button> + Add New Business</button>
                  </div> */}
                </div>
              </div>
              // )
            }
          </div>
        </div>
      )}

      {/* {shimmerEffect ? (
                <div className="no_data_v2 text-center">
                  <img src={dataLoading} alt="" />
                </div>
              ) : */}
      
      <>
        {partnerFullData && (
          <div className="table_partner">
            <div className="Buissness-main">
              <div className="left-wrapper table_data">
                <div className="left-header">
                  <div className="App">
                    <Dropdown>
                      <Dropdown.Toggle variant="Secondary" id="dropdown-basic">
                        {selectedChoice.label}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {choices.map((item, index) => (
                          <Dropdown.Item
                            key={index}
                            onClick={() => handleChoiceSelection(item)}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="mx-3 d-flex align-items-center">
                    <div className="grid_view">
                      <img
                        src={fullScreen}
                        alt=""
                        onClick={() => {
                          setTablevar(false);
                          setpartnerFullData(false);
                          localStorage.setItem("businessGridView", '0')
                        }}
                      />
                      <span></span>
                    </div>
                    {records && records["number_of_records"] > 0 && <div>
                      <Dropdown>
                        <Dropdown.Toggle variant="Secondary" id="dropdown-basic" disabled={listData && listData.length == 0}>
                          <img src={exports} alt="" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => exportdcotorList(exportType.XLSX)}
                          >
                            XLSX
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => exportdcotorList(exportType.CSV)}
                          >
                            CSV
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>}
                    {/* {listData && listData.length > 0 && (
                            <div className="cursor" onClick={downloadPDF}>
                              <img src={Download} alt="" />
                              <span className="ms-2">Pdf</span>
                            </div>
                          )} */}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="search-bar grid_search search-bar-v2" >
                    <input
                    id="search-input"
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      name="search"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          doctorList(0, false);
                        }
                      }}
                      disabled={listData && listData.length == 0}
                    />

                    {(searchInput || (dateFilterData && dateFilterData.startDate)) && (
                      <label className="filter" onClick={deleteData}></label>
                    )}

                    <div onClick={() => setShow(true)} className="date_range">
                      <img src={filterSearch} alt="" />
                    </div>
                  </div>

                  <div className="" onClick={() => navigate("/app/new-business")}>
                    <button id="new-buss"> + Add New Business</button>
                  </div>
                </div>
              </div>
            </div>
            {
              shimmerEffect ? (
                <div className="no_data_v2 text-center">
                  <img src={dataLoading} alt="" />
                </div>
              ) : (
                listData && listData.length > 0 ? (
                  <Table callFunction={(index: any) => receiveData(index)} data={rows} columns={columns}></Table>
                ) : (
                  <NoDataRightScreen />
                ))}
            {records && records["number_of_records"] > 10 && (
              <div>
                <Pagination
                  totalItems={records && records["number_of_records"]}
                  itemsPerPage={records && records["number_of_pages"]}
                  onPageChange={(offset: number) =>
                    handlePageChange(offset)
                  }
                />
              </div>
            )}
          </div>
        )} </>
      {/* } */}

      {exportCSVData.data && exportCSVData.data.length != 0 && (
        <CSVLink
          data={exportCSVData.data}
          headers={exportCSVData.headers}
          filename={"BusinessList.csv"}
          id="custom-hidden"
        />
      )}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        {show && (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            className="date_modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Date Range</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {" "}
              <div>
                <DateRangePicker
                  ranges={[selectionRange]}
                  onChange={handleSelect}
                  inputRanges={[]}
                  showMonthArrow={true}
                  showMonthAndYearPickers={true}
                  maxDate={new Date()}
                // showDateDisplay={false}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button id="close-picker" className="" onClick={() => setShow(false)}>
                Close
              </Button>
              <Button
                onClick={() => {
                  setShow(false);
                  doctorList(0, false, false, 0, true);
                }}
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>

      {showDeleteModal && (
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          className="delete_date_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Are you sure you want to delete this note ?</div>
          </Modal.Body>
          <Modal.Footer>
            <Button
            id="cancelDelete"
              className=""
              onClick={() => {
                setShowDeleteModal(false);
                setDeleteAnId(0);
              }}
            >
              Cancel
            </Button>
            <Button
             id="deleteConfirm"
              style={{ border: "solid 1px" }}
              disabled={sppiner}
              onClick={() => {
                // setShowDeleteModal(false);
                deleteConfirm();
                // subage(0, false, false, 0, true);
              }}
            >
              <span className="mr-3">Delete</span>
              {sppiner && (
                <Spinner
                  style={{ marginLeft: "5px" }}
                  as="span"
                  className="ml-2"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Businesses;
